var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnbilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "182.000000pt",
    height: "184.000000pt",
    viewBox: "0 0 182.000000 184.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,184.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720 1679 c-87 -22 -196 -73 -258 -118 l-42 -31 53 -56 53 -55 55 36 c56 37 126 67 204 86 l45 11 0 74 c0 86 5 83 -110 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1629 l0 -75 71 -18 c283 -73 480 -324 479 -610 -1 -266 -182 -516 -430 -594 -36 -11 -77 -23 -92 -26 -27 -6 -28 -8 -28 -80 l0 -73 58 8 c33 5 94 22 136 38 307 118 506 406 506 731 0 258 -145 518 -364 655 -83 52 -210 101 -285 111 l-51 7 0 -74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 1378 c-42 -56 -95 -172 -117 -254 -31 -118 -33 -114 53 -114 l74 0 13 58 c17 69 50 148 87 203 l26 40 -48 49 c-27 28 -53 50 -57 50 -4 0 -18 -15 -31 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 1004 c-101 -101 -186 -184 -190 -184 -4 0 -43 36 -87 80 l-81 80 -39 -40 -39 -40 122 -123 122 -122 232 232 232 232 -35 35 c-19 20 -38 35 -44 35 -5 -1 -92 -84 -193 -185z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 824 c0 -76 84 -285 144 -359 l25 -30 53 53 c46 45 51 54 40 70 -33 47 -83 157 -98 216 l-16 66 -74 0 c-61 0 -74 -3 -74 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 370 l-53 -48 43 -33 c62 -45 194 -106 270 -124 103 -24 99 -26 99 60 0 71 -1 75 -22 75 -37 1 -155 46 -220 84 -32 20 -60 36 -61 36 -1 -1 -26 -23 -56 -50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbilled);
export default __webpack_public_path__ + "static/media/Unbilled.a2a2bee8.svg";
export { ForwardRef as ReactComponent };